//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { questionOwnerType } from '@/server/constants'

export default {
  name: 'CopyQuestionsModal',
  props: {
    // Can accept either template or project - flexible prop
    source: {
      type: Object,
      required: true
    },
    // Specify the source type to determine behavior
    sourceType: {
      type: String,
      required: true,
      validator: value => ['template', 'project'].includes(value)
    }
  },
  data() {
    return {
      selectedCopyOption: null,
      availableTemplates: [],
      selectedTemplateIds: [],
      loadingTemplates: false,
      copyingToTemplates: false,
      availableProjects: [],
      selectedProjectIds: [],
      loadingProjects: false,
      copyingToProjects: false,
      copyResult: null,
      // which list the results modal shows: 'copied' or 'notCopied'
      resultView: 'notCopied',
      // navigation to run once the user closes the results modal
      afterCopyResults: null
    }
  },
  computed: {
    ...mapGetters({
      questionsSelected: 'questions/getQuestionsSelected',
      templates: 'templates/getTemplates',
      projects: 'projects/getProjectList',
      isAdmin: 'user/isAdmin'
    }),
    // Helper computed properties for cleaner code
    isTemplate() {
      return this.sourceType === 'template'
    },
    isProject() {
      return this.sourceType === 'project'
    },
    sourceName() {
      return this.source?.name || ''
    },
    sourceId() {
      return this.source?._id || null
    },
    resultGroups() {
      if (!this.copyResult) {
        return []
      }
      return this.resultView === 'copied' ? this.copyResult.copied : this.copyResult.notCopied
    }
  },
  mounted() {
    localStorage.removeItem('pendingQuestionsCopy')
  },
  methods: {
    ...mapActions({
      fetchTemplateList: 'templates/fetchTemplateList',
      fetchProjectList: 'projects/fetchProjectList',
      bulkAddQuestions: 'questions/bulkAddQuestions',
      setQuestionsSelect: 'questions/setQuestionsSelect'
    }),
    // project descriptions are rich text (Quill HTML) as of LSO-719 — strip
    // the markup for this plain-text preview
    stripHtml(value) {
      if (!value) {
        return ''
      }
      return value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
    },
    showCopyModal() {
      this.selectedCopyOption = null
      this.$bvModal.show('copy-questions-modal')
    },
    hideCopyModal() {
      this.$bvModal.hide('copy-questions-modal')
    },
    selectCopyOption(option) {
      this.selectedCopyOption = option
    },
    proceedWithCopy() {
      if (!this.selectedCopyOption) {
        return
      }
      
      const actions = {
        existing: () => this.copyToExistingTemplate(),
        new: () => this.createNewTemplate(),
        project: () => this.copyToProject(),
        newProject: () => this.createNewProject()
      }
      
      const action = actions[this.selectedCopyOption]
      if (action) {
        action()
      }
      
      this.$bvModal.hide('copy-questions-modal')
    },
    
    // Template related methods
    copyToExistingTemplate() {
      this.showTemplateSelectionModal()
    },
    async showTemplateSelectionModal() {
      this.selectedTemplateIds = []
      this.loadingTemplates = true
      
      this.$bvModal.hide('copy-questions-modal')
      this.$bvModal.show('template-selection-modal')
      
      try {
        await this.fetchTemplateList()
        
        this.availableTemplates = this.templates.filter((t) => {
          // For templates, exclude current template
          if (this.isTemplate && this.sourceId && t._id === this.sourceId) {
            return false
          }
          
          // For system templates (no user), only include if user is admin
          if (!t.user && !t.org) {
            return false
          }
          
          return true
        })
      } catch (error) {
        console.error('Error fetching templates:', error)
        this.$bvToast.toast('Failed to load templates. Please try again.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        })
      } finally {
        this.loadingTemplates = false
      }
    },
    cancelTemplateSelection() {
      this.$bvModal.hide('template-selection-modal')
      this.$bvModal.show('copy-questions-modal')
    },
    async copyQuestionsToSelectedTemplates() {
      if (this.selectedTemplateIds.length === 0) {
        return
      }
      
      this.copyingToTemplates = true
      
      try {
        const result = await this.performBulkCopy(this.selectedTemplateIds, 'template')
        
        this.$bvModal.hide('template-selection-modal')
        this.selectedTemplateIds = []
        this.clearSelections()
        
        this.showCopyResults(result, result.copiedCount > 0 ? () => this.$router.push('/templates') : null)
      } catch (error) {
        console.error('Error copying questions to templates:', error)
        this.$bvToast.toast('An unexpected error occurred while copying questions.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        })
      } finally {
        this.copyingToTemplates = false
      }
    },
    
    // Project related methods
    copyToProject() {
      this.showProjectSelectionModal()
    },
    async showProjectSelectionModal() {
      this.selectedProjectIds = []
      this.loadingProjects = true
      
      this.$bvModal.hide('copy-questions-modal')
      this.$bvModal.show('project-selection-modal')
      
      try {
        await this.fetchProjectList()
        
        this.availableProjects = this.projects.filter((p) => {
          // Exclude current project if source is project
          if (this.isProject && this.sourceId && p._id === this.sourceId) {
            return false
          }
          
          // Include only new projects (status 0)
          return p.status === 0
        })
      } catch (error) {
        console.error('Error fetching projects:', error)
        this.$bvToast.toast('Failed to load projects. Please try again.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        })
      } finally {
        this.loadingProjects = false
      }
    },
    cancelProjectSelection() {
      this.$bvModal.hide('project-selection-modal')
      this.$bvModal.show('copy-questions-modal')
    },
    async copyQuestionsToSelectedProjects() {
      if (this.selectedProjectIds.length === 0) {
        return
      }
      
      this.copyingToProjects = true
      
      try {
        const result = await this.performBulkCopy(this.selectedProjectIds, 'project')
        
        this.$bvModal.hide('project-selection-modal')
        this.selectedProjectIds = []
        this.clearSelections()
        
        // Refresh current route
        this.showCopyResults(result, result.copiedCount > 0 ? () => this.$router.go(0) : null)
      } catch (error) {
        console.error('Error copying questions to projects:', error)
        this.$bvToast.toast('An unexpected error occurred while copying questions.', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        })
      } finally {
        this.copyingToProjects = false
      }
    },
    
    // Create new methods
    createNewTemplate() {
      this.createNew('template')
    },
    createNewProject() {
      this.createNew('project')
    },
    createNew(targetType) {
      if (!this.sourceId) {
        console.error('Source not available for creating new', targetType)
        return
      }
      
      const questionsToStore = this.prepareQuestionsForCopy()
      const copyData = {
        questions: questionsToStore,
        sourceId: this.sourceId,
        sourceName: this.sourceName,
        sourceType: this.sourceType,
        targetType,
        timestamp: Date.now()
      }
      
      localStorage.setItem('pendingQuestionsCopy', JSON.stringify(copyData))
      
      const targetName = targetType === 'template' ? 'template' : 'project'
      const targetRoute = targetType === 'template' ? '/templates/add' : '/projects/add'
      
      this.$bvToast.toast(
        `You'll be taken to create a new ${targetName}. Your ${questionsToStore.length} selected questions will be automatically copied to the new ${targetName} after you create it.`,
        {
          title: `Creating New ${targetName.charAt(0).toUpperCase() + targetName.slice(1)}`,
          variant: 'info',
          autoHideDelay: 4000,
          solid: true,
          toaster: 'b-toaster-top-right'
        }
      )
      
      this.$router.push(targetRoute)
    },
    
    // Utility methods
    prepareQuestionsForCopy() {
      return this.questionsSelected.map((q) => {
        const questionCopy = { ...q }
        
        // Remove metadata that will be regenerated
        delete questionCopy._id
        delete questionCopy.created
        delete questionCopy.updated
        delete questionCopy.owner
        delete questionCopy.ownerType
        
        // Clean up categories
        if (!questionCopy.primaryCategory || questionCopy.primaryCategory === 'Uncategorized') {
          delete questionCopy.primaryCategory
        }
        if (!questionCopy.secondaryCategory || questionCopy.secondaryCategory === 'Uncategorized') {
          delete questionCopy.secondaryCategory
        }
        if (!questionCopy.tertiaryCategory || questionCopy.tertiaryCategory === 'Uncategorized') {
          delete questionCopy.tertiaryCategory
        }
        
        return questionCopy
      })
    },
    async performBulkCopy(targetIds, targetType) {
      const questionsToStore = this.prepareQuestionsForCopy()
      const ownerType = targetType === 'template' ? questionOwnerType.template : questionOwnerType.project
      const targetItems = targetType === 'template' ? this.availableTemplates : this.availableProjects
      
      // [{ targetName, questions: [text] }] per target with questions copied
      const copied = []
      // [{ targetName, reason, questions: [text] }] per target with questions left out
      const notCopied = []
      
      for (const targetId of targetIds) {
        const targetName = targetItems.find(t => t._id === targetId)?.name || `Unknown ${targetType}`
        try {
          const questionsForTarget = questionsToStore.map(q => ({
            ...q,
            owner: targetId,
            ownerType,
            tagLocked: true
          }))
          
          // duplicates already in the target are skipped server-side rather
          // than failing the whole copy
          const result = await this.bulkAddQuestions({ questions: questionsForTarget, skipDuplicates: true })
          const inserted = result?.questions || []
          if (inserted.length > 0) {
            copied.push({ targetName, questions: inserted.map(q => this.questionLabel(q)) })
          }
          const skipped = result?.skipped || []
          
          if (skipped.length > 0) {
            notCopied.push({
              targetName,
              reason: `Already exists in this ${targetType}`,
              questions: skipped.map(q => this.questionLabel(q))
            })
          }
        } catch (error) {
          notCopied.push({
            targetName,
            reason: error.response?.data?.message || error.message || 'Unexpected error',
            questions: questionsToStore.map(q => this.questionLabel(q))
          })
          console.error(`Error copying questions to ${targetType} ${targetId}:`, error)
        }
      }
      
      const countQuestions = groups => groups.reduce((sum, group) => sum + group.questions.length, 0)
      return {
        targetType,
        targetCount: targetIds.length,
        selectedCount: questionsToStore.length,
        copiedCount: countQuestions(copied),
        notCopiedCount: countQuestions(notCopied),
        copied,
        notCopied
      }
    },
    questionLabel(question) {
      return this.stripHtml(question.text) || question.tag
    },
    showCopyResults(result, afterClose) {
      this.copyResult = result
      this.resultView = result.notCopiedCount ? 'notCopied' : 'copied'
      this.afterCopyResults = afterClose
      this.$bvModal.show('copy-results-modal')
    },
    onCopyResultsClosed() {
      const afterClose = this.afterCopyResults
      this.copyResult = null
      this.afterCopyResults = null
      if (afterClose) {
        afterClose()
      }
    },
    clearSelections() {
      this.setQuestionsSelect({ project: {}, property: {}, status: false, questions: [] })
    }
  }
}
